import React from 'react';
import { Link } from 'react-router-dom';
import { customerOrderStatusLabel, getOrderId, getOrderItems, orderDate, orderGrandTotal } from '../utils/orderPresentation';
import OrderProductList from './OrderProductList';

export default function CustomerOrderPreview({ order }) {
  const items = getOrderItems(order);
  return <article className="profile-order-preview">
    <div className="profile-order-preview-heading">
      <strong>{orderDate(order)}</strong>
      <span>{customerOrderStatusLabel(order.status)}</span>
    </div>
    <OrderProductList items={items.length ? items : order.product_title ? [order] : []} limit={3} />
    <strong>Итого: {orderGrandTotal(order).toLocaleString('ru-RU')} ₽</strong>
    <Link className="customer-login-link" to={`/orders/${getOrderId(order)}`}>Подробнее о заказе</Link>
  </article>;
}
